import {Linking} from 'react-native';
import {showErrorMessage} from '../service/flashMessage';

const openAppSettings = async (context = 'settings') => {
  try {
    await Linking.openSettings();
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    showErrorMessage(`Unable to open ${context}: ${message}`);
  }
};

export default openAppSettings;
